'use strict'

import angular from 'angular'

angular.module('core.buysheetflightfield.services', [])
    .factory('BuySheetFlightFieldFactory', BuySheetFlightFieldFactory)

/**
 * @ngInject
 */
function BuySheetFlightFieldFactory(
    Restangular,
    ColumnValueType
) {
    var buySheetFlightFields = Restangular.all('buysheetflightfields')
    var vars = buySheetFlightFields.one('vars')
    var values = buySheetFlightFields.one('values')

    /**
     *
     * @param queryParams
     * @returns {*|ICollectionPromise<T>|ICollectionPromise<any>|{method, params, headers}}
     */
    function getColumns(queryParams) {
        return buySheetFlightFields.getList(_.extend({
            metadata: true,
            sort: 'label'
        }, queryParams));
    }

    /**
     * Get all selectable values for specific fields (enum values)
     * @param fields (fields can be undefined to fetch all)
     * @returns {*}
     */
    function getColumnValues(fields) {
        return values.one(ColumnValueType.SET).get(_.isUndefined(fields) ? '' : {fields: fields});
    }

    /**
     * Get all distinct values for specific fields
     * @param fields (fields can be undefined to fetch all)
     * @dataSource unused
     * @queryParams any additional query params
     * @returns {*}
     */
    function getFieldValues(fields, dataSource, queryParams) {
        return values.one(ColumnValueType.DISTINCT).get(
            _.extend(_.isUndefined(fields) ? {} : {fields: fields}, queryParams || {}));
    }

    /**
     * Get data for this resource
     * @param queryParams
     * @returns {*|ICollectionPromise<any>|ICollectionPromise<T>|{method, params, headers}}
     */
    function getData(queryParams) {
        return buySheetFlightFields.getList(queryParams);
    }

    return {
        ecTasksSummary: buySheetFlightFields,
        vars: vars,
        getColumns: getColumns,
        getColumnValues: getColumnValues,
        getFieldValues: getFieldValues,
        getData: getData
    }
}